import { useContext } from "react";
import { MyActionPlanContext } from "./context";

export const useMyActionPlanContext = () => {
    const context = useContext(MyActionPlanContext);

    if (context) {
        return context;
    }

    throw new Error(`useMyActionPlanContext must be used within the context`);
};
